export enum ReadingType {
    INITIAL_READING = 'INITIAL_READING',
    REGULAR_READING = 'REGULAR_READING',
    COMPLIANCE_RECOVERY_READING = 'COMPLIANCE_RECOVERY_READING',
    DEACTIVATION_READING = 'DEACTIVATION_READING',
}